/* eslint no-undef: 0 */
/* eslint arrow-parens: 0 */
import React from 'react';
import { enquireScreen } from 'enquire-js';

import Banner3 from './Banner3';
import Content0 from './Content0';

import {Banner32DataSource, Content00DataSource } from './data.source';
import './less/antMotionStyle.less';

let isMobile;
enquireScreen((b) => {
  isMobile = b;
});

const { location = {}, hangYeList} = typeof window !== 'undefined' ? window : {};

class DongTai extends React.Component {
  constructor(props) {
    console.log('hangYeList数据',hangYeList);
    super(props);
    this.state = {
      isMobile,
      show: !location.port, // 如果不是 dva 2.0 请删除
    };
  }

  componentDidMount() {
    // 适配手机屏幕;
    enquireScreen((b) => {
      this.setState({ isMobile: !!b });
    });
    // dva 2.0 样式在组件渲染之后动态加载，导致滚动组件不生效；线上不影响；
    /* 如果不是 dva 2.0 请删除 start */
    if (location.port) {
      // 样式 build 时间在 200-300ms 之间;
      setTimeout(() => {
        this.setState({
          show: true,
        });
      }, 500);
    }
    /* 如果不是 dva 2.0 请删除 end */
  }

  render() {
    const children = [
      <Banner3
        id="Banner3_2"
        key="Banner3_2"
        dataSource={Banner32DataSource}
        isMobile={this.state.isMobile}
      />,
      <Content0
        id="Content1_0"
        key="Content1_0"
        dataSource={Content00DataSource}
        isMobile={this.state.isMobile}
      />,
    ];
    return (
      <div
       
      >
        {/* 如果不是 dva 2.0 替换成 {children} start */}
        {this.state.show && children}
        {/* 如果不是 dva 2.0 替换成 {children} end */}
      </div>
    );
  }
}


export default  DongTai